import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

export interface StatCard {
  icon: string;
  value: number | string;
  label: string;
  change?: {
    value: string;
    type: 'positive' | 'negative' | 'neutral';
  };
  iconClass?: string;
  // Speciális formátum az első kártyához (Indított hívás A/P)
  specialFormat?: {
    actualValue: number;
    planValue: number;
  };
}

@Component({
  selector: 'app-overview-card',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule
  ],
  templateUrl: './overview-card.component.html',
  styleUrl: './overview-card.component.scss'
})
export class OverviewCardComponent implements OnInit, OnChanges {
  @Input() stat!: StatCard;

  ngOnInit() {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    
  }
}